import { useAlert } from '../context/AlertContext';
import { deleteCompetitionTeam } from '../api/api';
import { FaCheck } from 'react-icons/fa';

function BreadC({
  setStep,
  competition,
  divisionSelection,
  setTeam,
  setEditingTeam,
  setTeamName,
  step,            // this is the current stepNumber (e.g., 0..3)
  team,
  editingTeam,
}) {
  const { showAlert } = useAlert();

  const steps = [
    { label: 'Select Competition', action: 'competition_selection', visible: true, stepNumber: 0 },
    { label: 'Select Division',    action: 'division_selection',   visible: competition && competition.division_split, stepNumber: 1 },
    { label: 'Create Team',        action: 'create_team',          visible: true, stepNumber: 2 },
    { label: 'Add Team Members',   action: 'invite',               visible: true, stepNumber: 3 },
  ];

  // Keep order by stepNumber; filter visibility
  const visibleSteps = steps
    .filter(s => s.visible)
    .sort((a, b) => a.stepNumber - b.stepNumber);

  const navToTeamMembers = () => {
    if (competition && !competition.division_split) {
      setStep(2); // stepNumber
    } else if (competition && competition.division_split && !divisionSelection) {
      showAlert(['You need to select a division.'], 'Validation Error');
    } else if (!competition) {
      showAlert(['You need to select a competition.'], 'Validation Error');
    }
  };

  const handleStep = async (nextStepNumber, action) => {
    if (step === 3 && nextStepNumber !== 3) {
      showAlert(
        ['Leaving this page while creating/editing a team will result in the team being removed from the competition.'],
        'Warning',
        async () => {
          try {
            await deleteCompetitionTeam(team.id);
            setStep(nextStepNumber);
            setEditingTeam(false);
            setTeam(null);
            setTeamName('');
          } catch (error) {
            console.error('Failed to delete team:', error);
          }
        }
      );
    } else if (step === 2 && nextStepNumber !== 2 && editingTeam) {
      showAlert(
        ['Leaving this page while editing a team will result in the team being removed from the competition.'],
        'Warning',
        async () => {
          try {
            await deleteCompetitionTeam(team.id);
            setStep(nextStepNumber);
            setEditingTeam(false);
            setTeam(null);
            setTeamName('');
          } catch (error) {
            console.error('Failed to delete team:', error);
          }
        }
      );
    } else if (action === 'create_team') {
      navToTeamMembers();
    } else {
      setStep(nextStepNumber);
    }
  };

  return (
    <div className="block w-full max-w-4xl mx-auto mt-6 px-4">
      {/* ROW 1: dots + connecting lines */}
      <div className="flex items-center">
        {visibleSteps.map((s, i) => {
          const isActive = step === s.stepNumber;
          const isCompleted = step > s.stepNumber;

          const prevVisible = i > 0 ? visibleSteps[i - 1] : null;
          const nextVisible = i < visibleSteps.length - 1 ? visibleSteps[i + 1] : null;

          return (
            <div key={s.stepNumber} className="flex-1 relative flex justify-center">
              {/* left connector: filled if current step >= this stepNumber */}
              {prevVisible && (
                <div
                  className={`absolute top-1/2 left-0 right-1/2 h-0.5 -translate-y-1/2 ${
                    step >= s.stepNumber ? 'bg-yellow-500' : 'bg-gray-300'
                  }`}
                />
              )}

              {/* right connector: filled if current step >= next visible stepNumber */}
              {nextVisible && (
                <div
                  className={`absolute top-1/2 left-1/2 right-0 h-0.5 -translate-y-1/2 ${
                    step >= nextVisible.stepNumber ? 'bg-yellow-500' : 'bg-gray-300'
                  }`}
                />
              )}

              {/* dot */}
              <button
                type="button"
                onClick={() => handleStep(s.stepNumber, s.action)}
                className={`w-6 h-6 rounded-full flex items-center justify-center border-2 z-10 transition-all duration-300
                  ${isActive ? 'bg-yellow-500 border-yellow-500' : 'bg-gray-300 border-gray-300'}
                `}
                aria-label={s.label}
              >
                {isActive ? (
                  <FaCheck className="w-3.5 h-3.5 text-white" />
                ) : (
                  <span className="w-2 h-2 bg-white rounded-full" />
                )}
              </button>
            </div>
          );
        })}
      </div>

      {/* ROW 2: labels */}
      <div className="mt-2 flex">
        {visibleSteps.map((s) => {
          const isActive = step === s.stepNumber;
          return (
            <button
              key={s.stepNumber}
              type="button"
              onClick={() => handleStep(s.stepNumber, s.action)}
              className={`flex-1 text-center text-sm transition-colors ${
                isActive ? 'text-yellow-500 font-semibold' : 'text-gray-700'
              }`}
            >
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default BreadC;
